module.exports = "https://www.gc-pro.gnp.com.mx/377a887fb34563cffbc632e051ac9d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-cobranza-vida.svg
// module id = 8079
// module chunks = 0